export const JrnyPermissions = {
  JRNY_ORGANIZATION_LIST: 'journey-admin:organization:list',
  JRNY_ORGANIZATION_CREATE: 'journey-admin:organization:create',
  JRNY_SETTINGS_VIEW: 'journey-admin:settings:view',
  JRNY_SETTINGS_SAVE: 'journey-admin:settings:save',
  JRNY_SETTINGS_REMOVE: 'journey-admin:settings:remove',
  JRNY_MAINTENANCE_VIEW: 'journey-admin:maintenance:view',
};
